<template>
  <div>
    <LineWrapper v-if="chartData">
      <template v-if="filterBy" #filter>
        <FilterComponent v-model="filterValue" :label="filterBy.label" :items="filterBy.values" @input="handleFilter" />
      </template>
      <template v-if="hasLinearData" #content
        ><LineChart class="statistics-projects-timeline__chart" :chart-data="chartData" :options="chartOptions"
      /></template>
      <template v-else #content>
        <component :is="fallback.tag || 'p'" v-bind="fallback.props">{{ fallback.label }}</component>
      </template>
      <template #dimensions>
        <h3>{{ heading }}</h3>
        <ul v-if="dimensions && hasLinearData">
          <li v-for="dimension of dimensions" :key="dimension.id">
            <span v-if="dimension.marker" class="kvass-line__bg-label" :style="{ backgroundColor: dimension.marker }" />
            <span v-if="dimension.icon" class="">{{ dimension.icon }}</span>
            <span>{{ dimension.label }}</span>
            <span v-if="total && total[dimension.id]">({{ total[dimension.id] }})</span>
          </li>
        </ul>
      </template>
    </LineWrapper>
    <component v-else :is="fallback.tag || 'p'" v-bind="fallback.props">{{ fallback.label }}</component>
  </div>
</template>

<script>
import LineChart from '@/components/Charts/ChartJS/Line'
import LineWrapper from '@/components/Charts/LineWrapper'
import FilterComponent from '@/components/Analytics/Filter/Dropdown'

export default {
  props: {
    data: Object,
    source: Object,
  },
  data() {
    return {
      filterValue: this.source.filterBy.initial,
    }
  },
  computed: {
    filterBy() {
      if (!this.source || !this.source.filterBy) return null
      return this.source.filterBy
    },
    heading() {
      if (!this.source || !this.source.heading) return ''
      return typeof this.source.heading === 'function'
        ? this.source.heading({ data: this.data, source: this.source })
        : this.source.heading
    },
    dimensions() {
      if (!this.source || !this.data) return
      return typeof this.source.dimensions === 'function'
        ? this.source.dimensions({ data: this.data, source: this.source, colors: this.colors })
        : this.source.dimensions
    },
    total() {
      if (!this.source || !this.data || !this.source.total) return
      return typeof this.source.total === 'function'
        ? this.source.total({ data: this.data, source: this.source })
        : this.source.total
    },
    colors() {
      if (!this.source || !this.data) return
      return typeof this.source.colors === 'function'
        ? this.source.colors({ data: this.data, source: this.source })
        : this.source.colors
    },
    chartData() {
      if (!this.data) return {}
      return typeof this.source.data === 'function'
        ? this.source.data({
            source: this.source,
            data: this.data,
            dimensions: this.dimensions,
            colors: this.backgroundColors,
          })
        : this.source.data
    },
    chartOptions() {
      if (!this.source.options) return {}
      return typeof this.source.options === 'function'
        ? this.source.options({
            source: this.source,
            data: this.data,
          })
        : this.source.options
    },
    fallback() {
      if (!this.source.fallback) return { label: this.$t('statisticsEmptyState') }
      return typeof this.source.fallback === 'function'
        ? this.source.fallback({ data: this.data, source: this.source })
        : this.source.fallback
    },
    hasLinearData() {
      return this.chartData && this.chartData.datasets
        ? this.chartData.datasets.filter(v => v.data && v.data.filter(Boolean).length > 0).length > 0
        : false
    },
  },
  methods: {
    handleFilter(filter) {
      this.filterValue = filter.value
      this.$emit('linearFilter', { source: this.source, filter })
      if (this.source.handleFilter && typeof this.source.handleFilter === 'function')
        this.source.handleFilter.call(this, { source: this.source, filter })
    },
  },
  components: {
    FilterComponent,
    LineWrapper,
    LineChart,
  },
}
</script>

<style lang="scss">
.statistics-projects-timeline {
  &__chart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}
</style>
